import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var LayerNode = /*#__PURE__*/function () {
  function LayerNode(id, parent) {
    _classCallCheck(this, LayerNode);
    this.id = id;
    this.childNodes = [];
    this.parent = parent;
  }
  return _createClass(LayerNode, [{
    key: "addChild",
    value: function addChild(node) {
      this.childNodes.push(node);
    }
  }, {
    key: "removeChild",
    value: function removeChild(node) {
      this.childNodes = this.childNodes.filter(function (child) {
        return child.id !== node.id;
      });
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      if (!this.parent) {
        return 1;
      }
      return this.parent.getLevel() + 1;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      if (this.childNodes.length === 0) {
        return 1;
      }
      return Math.max.apply(Math, _toConsumableArray(this.childNodes.map(function (child) {
        return child.getHeight();
      }))) + 1;
    }
  }]);
}();